module.exports = __webpack_public_path__ + "assets/img/third-screenshot-mob.e0b4a8dd.png";